export const FIREBASE_SUCCESS = 'success';
